import {UserSubscriptionPlan} from "./user-subscription-plan";
import {Config} from "../config/config";

export const UserSubscriptionType = {
  FREE: 'starter',
  GHOST: 'ghost',
  REGISTERED: 'registered',
  ONE_PRODUCT: 'one_product',
  PREMIUM: 'bundle',
  APPSUMO: 'appsumo',
  TENWEBX_LTD: '10WebX_ltd',
  PLATFORM: 'platform',
  DEDICATEDVM: 'dedicated_vm',
  TENWEBX_RECURRING: '10webX',
  BOOSTER: 'booster',
  INVITED: 'invited',
};

export enum UserSubscriptionCategory {
  NONE = 'none',
  STARTER = 'starter',
  APPSUMO = 'appsumpo',
  REGISTERED = 'registered',
  PERSONAL = 'personal',
  PREMIUM = 'premium',
  ENTERPRISE = 'enterprise',
  CUSTOM = 'custom',
  PROFESSIONAL = 'professional',
  ENTERPRISE_ULTIMATE = 'enterprise-ultimate',
  PROFESSIONAl = 'professional',
  AGENCY = 'agency',
  PLATFORM = 'platform',
  DedicatedVM = 'dedicated_vm',
  BOOSTER = 'booster',
  TENWEBX_LTD_PLUS = '10WebX_ltd_plus',
  TENWEBX_LTD_FREELANCER = '10WebX_ltd_freelancer',
  TENWEBX_LTD_EXPERT = '10WebX_ltd_expert',
  TENWEBX_LTD_UNLIMITED = '10WebX_ltd_unlimited',
}



export enum UserSubscriptionIds {
  TRIAL = 211,
  TRIAL_NEW = Config.defaultStarterPlanId,
  TRIAL_OPTIMIZER = 257,
  FREE_BASE = Config.basePlanId,
  TRIAL_BOOSTER = Config.speedStarterPlanId,
  FREE = Config.defaultStarterPlanId,
  BOOSTER_BETA = Config.boosterBetaPlanId,
  TRIAL_BUILDER = 261,
  INVITED = 315,
  BUILDER = 316,
  API_RESELLER = Config.apiResellerPlanId,
}

export class UserSubscription {

  public id: number;
  public corePlanId: number;
  public type: string;
  public category: UserSubscriptionCategory;
  public title: string;
  public pluginTitle: string;
  public productSlug: string;
  public agreementDate: Date;
  public nextBillingDate: Date;
  public expireDate: Date;
  public isExpired: boolean;
  public cancelDate: Date | null;
  public pausedExpirationDate: Date = null;
  public clientId: number;
  public planId: number;
  public subscriptionId: number;
  public periodNumber: number;
  public trialClient: boolean;
  public trialOptimizerClient: boolean;
  public boosterProClient: boolean;
  public platformPaidClient: boolean;
  public paidClient: boolean;
  public trialBoosterClient: boolean;
  public professionalPlan: boolean;
  public freeBaseClient: boolean;
  public boosterBetaClient: boolean;
  public oneProductClient: boolean;
  public bundleClient: boolean;
  public oneProductOrBundle: boolean;
  public hasProfessionalWebsite: boolean;
  public hasEcommerceWebsite: boolean;
  public defaultPrice: number;
  public defaultPrice1: number;
  public plan: UserSubscriptionPlan;
  public plans: UserSubscriptionPlan[];
  public status: string;
  public recharge: boolean;
  public subscriptionTitle: string;
  public subscriptionTitleName: string;
  public subscriptionOriginalTitle: string;
  public paymentFailed: boolean;
  public paymentFailedCount: any;
  public isDefault: boolean;
  public realStatus: string;
  public firstPaymentDate: Date;
  public canReactivate: boolean;
  public additionalWebsiteCount: any;
  public paymentType: any;
  public product_id: any;
  public paypalEmail: any;
  public appsumoIsExpired: any;
  public hostingTrialExpireDate: any;
  public hasHostingTrial: any;
  public hostingTrialExpired: any;
  public couponCode: string;
  public lifetimeCoupon: boolean;
  public couponApplyDaysForRenew: number;
  public domainsPermission: {
    canConnectWebsite: boolean;
    canConnectSpeedWebsite: boolean;
    canConnectAIWebsite: boolean;
    canCreateWebsite: boolean;
  };
  public canEnableCdn: boolean;
  public paused: boolean;
  public boosterCategory: string;
  public aiPrice: number;
  public boosterPrice: number;
  public freeDaysBeforePayment: number;
  public freeDaysAfterPayment: number;
  public isGeo: boolean;
  public coupleId: string;
  public isBusiness: boolean;
  public isAgency: boolean;
  public isApiResellerPlan: boolean;
  public tabCategory: string;
  public newPlan: boolean;
  public dedicatedHosting: boolean;
  public variant: string;
  public decreased: string;
  public oldPersonalPlatform: boolean;
  public hasActiveDomainAgreement: boolean;
  public hasDomainAgreement: boolean;
  public apiResellerFree: boolean;
  public apiResellerPro: boolean;
  public isDedicatedVM: boolean;
  public dedicatedInfo: {
    cpuCore: string;
    phpWorkers: string;
    ram: string;
  };
  public agencyFeatures?:  {
      description: string;
      id: number;
      ordering: number;
      slug: string;
      title: string;
      value: string | null;
  }[];
  public isEcommerce: boolean;
  public presentableTitle: string;
  public available?: boolean = true;
  public agencyCustomerData?: {
    customer_id: string;
    provider_subscription_id: string;
  };
  public stripeSbcrstatus?: string;
  public discountPercent?: string;
  public monthlyPrice?: number;
  public discountAmount?: string;
  public amountWithoutDiscount?: number;
  public builderType?: string = null;
  public availableBuilder: 'wvc' | 'section_based';
  public multipleBuilder: boolean;
  public wvcUsage: any;
  public editUsed: number;
  public editTotal: number;
  public generationsUsed: number;
  public generationsTotal: number;
  public vibeWebsitesUsed: number;
  public vibeWebsitesTotal: number;
  public is_non_billable: boolean;

}

